const removeShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage = () => {
  localStorage.removeItem('anova_should_show_enter_password_to_link_facebook_toast_from_local_storage')
}

export default removeShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage
